import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import {
  getLiveEventStatus,
  i18nTranslate,
  jitsuSignUpRedirect,
  isFeatureEnabled,
  application,
  isB2BAccount,
  isB2B2C,
  getLocalStorage,
  getLocaleCodeFromUrl,
  IS_BROWSER,
  checkMysiteOrPersonalOffer,
  trackGTMEvents,
  convertToBoolean,
  getLocalePathParam,
} from 'src/utils'
import { isCrossMarketAllowed } from 'src/utils/marketUtils'
import { AiOutlineUser } from 'react-icons/ai'
import NuskinAccountIcon from './NuskinAccountIcon'
import { Link } from 'react-router-dom'
import {
  getAppConfig,
  getCookie,
  APPConfig,
} from 'config/appConfig'
import { customerContainer, listsContainer } from 'src/models'
import { pageNames } from 'src/routes/pathParams'
import { mobileMenuState } from '../mobileMenuState'
import {
  customerLogout,
  signInwithRedirect,
  signOutWithRedirect,
} from 'src/utils/signInUtils'
import { observable } from 'mobx'
import { SigninModal } from 'src/views/components'
import { MicroFrontendLoader } from 'src/views/components/MicroFrontends/MicroFrontendLoader'
import { unSubscribeEvent, subscribe } from 'src/pubsub'
import { PUBSUB } from 'src/pubsub/pubEventNames'
import { isEquinoxMysite, isEquinoxPOSite } from 'src/utils/mySiteUtils'
import { isFetchAllPromoCodeEnabled } from 'src/deps'
import './styles.scss'
@observer
class UserMenu extends React.Component {
  @observable isToShowSignInModal = false
  enableJITSU = convertToBoolean(getAppConfig()?.enableJITSU)
  subscribeInternalRouting = null
  subscribeSignOut = null

  constructor(props) {
    super(props)
    this.state = {
      isHovered: false,
    }
  }

  handleMobileMenu = event => {
    if (this.enableJITSU) {
      event?.preventDefault?.()
      jitsuSignUpRedirect()
    } else {
      if (application.isTabletOrSmaller) {
        mobileMenuState.toggleMenuVisibility()
      } else {
        trackGTMEvents({ event: 'Signup', eventType: 'simpCustColdFormStart' })
      }
    }
  }

  componentDidMount() {
    this.initializeListAPI()
  }

  componentWillUnmount() {
    unSubscribeEvent(this.subscribeInternalRouting)
    unSubscribeEvent(this.subscribeSignOut)
  }

  initializeListAPI = () => {
    const customerResponse =
      customerContainer?.profileResponse?.customer ||
      customerContainer?.profileResponse

    if (customerResponse?.id) {
      this.getListCallInit()
    } else {
      setTimeout(() => {
        this.initializeListAPI()
      }, 300)
    }

    this.subscribeToEvent()
  }

  subscribeToEvent = () => {
    this.subscribeInternalRouting = subscribe(
      PUBSUB.INTERNAL_ROUTING,
      this.handleInternalRouting
    )
    this.subscribeSignOut = subscribe(PUBSUB.SIGN_OUT, this.handleSignOutEvent)
  }

  handleInternalRouting = (eventName, options) => {
    const { path } = options || {}
    if (path) {
      const locale = getLocalePathParam()
      this.props.history.push(path?.replace(`/${locale}`, ''))
    }
  }

  handleSignOutEvent = () => {
    this.handleSignOutClick()
  }

  /**
   * GetList API should be triggered only after Customer API
   * @date 10/11/2023 - 4:57:06 PM
   */
  getListCallInit = () => {
    if (getCookie('x-role-user')) {
      listsContainer.initFavoritesAndSaveForLater(true)
    }
  }

  handleSignOutClick = async () => {
    customerLogout()
  }

  accountIcon = () => {
    return this.props?.isNuskinHeader ? (
      <NuskinAccountIcon
        className="mr-lg-1"
        style={{ fontSize: '24px', verticalAlign: 'middle' }}
      />
    ) : (
      <AiOutlineUser
        className="mr-lg-1"
        style={{ fontSize: '20px', verticalAlign: 'middle' }}
      />
    )
  }

  showMobileLogin = () => {
    this.isToShowSignInModal = true
  }

  handleHideSignInModal = () => {
    this.isToShowSignInModal = false
  }

  signInComponent = () => {
    const { isNuskinHeader = false } = this.props
    return (
      <>
        {APPConfig.getAppConfig().signInType === 'okta' ? (
          <>
            <button
              role="button"
              aria-label={i18nTranslate('header.signIn', 'Sign In', {
                nameSpace: 'ssr-resource',
              })}
              className={`${isNuskinHeader && 'nu-sign-text px-1'
                } header-oktasignout-text des-display-user pl-0`}
              onClick={signInwithRedirect}>
              {!isNuskinHeader && this.accountIcon()}
              {i18nTranslate('header.signIn', 'Sign In', {
                nameSpace: 'ssr-resource',
              })}
            </button>
            <div
              className="text-center mob-display-user"
              onClick={this.showMobileLogin}
              data-testid="qa-signin">
              {convertToBoolean(getAppConfig()?.disableSignTextMobileHeader)
                ? this.accountIcon()
                : i18nTranslate('header.signIn', 'Sign In', {
                  nameSpace: 'ssr-resource',
                })}
            </div>
          </>
        ) : (
          <>
            {/* <Link
              to={pageNames.signIn}
              className="header-sign-text mob-display-user"
              // onClick={this.handleMobileMenu}
              data-testid="qa-signin">
              {this.accountIcon()}
              <span className="sr-only">Sign In</span>
            </Link>
            <Link
              to={pageNames.signIn}
              className={`${
                isNuskinHeader && 'nu-sign-text px-1'
              } header-sign-text des-display-user`}
              onClick={this.handleMobileMenu}
              data-testid="qa-signin">
              {!isNuskinHeader && this.accountIcon()}
              {i18nTranslate('header.signIn', 'Sign In')}
            </Link> */}
          </>
        )}
      </>
    )
  }

  signUpComponent = () => {
    // console.log(`signUpComponent >>>>`, getAppConfig(), isB2B2C())
    const { isNuskinHeader = false } = this.props
    const { businessRelationship } = getAppConfig()
    let pageLink = ''

    if (businessRelationship === 'B2B' || isB2B2C()) {
      pageLink = pageNames.signUp
    } else {
      pageLink = pageNames.createAccount
    }
    let mysite
    try {
      if (typeof window !== 'undefined') {
        const shoppingContext = getLocalStorage('shoppingContext') || {}
        if (Object.keys(shoppingContext).length > 0) {
          const contextValue = shoppingContext?.context || ''
          if (contextValue == 'storefront') {
            mysite = {
              display: 'none',
            }
          }
        }
      }
    } catch (e) {
      console.error('JSON.parse may be an error SignUpForm.formInputOkta', e)
    }
    return (
      <>
        <Link
          to={this.enableJITSU ? '#' : pageLink}
          className={`${isNuskinHeader && 'nu-sign-text mx-1 d-lg-inline-block'
            } header-signup-text`}
          onClick={this.handleMobileMenu}
          data-testid="qa-signup"
          role="button"
          aria-label={i18nTranslate('header.signUp', 'Sign Up', {
            nameSpace: 'ssr-resource',
          })}
          style={mysite}>
          {isNuskinHeader && this.accountIcon()}
          {i18nTranslate('header.signUp', 'Sign Up', {
            nameSpace: 'ssr-resource',
          })}
        </Link>
      </>
    )
  }

  signOutComponent = () => {
    const { isNuskinHeader = false } = this.props
    return (
      <a
        // href="javascript:;"
        to={pageNames.home}
        className={`${isNuskinHeader ? 'nu-sign-text' : ''
          } header-signout-text`}
        onClick={this.handleSignOutClick}
        data-testid="qa-signout">
        {i18nTranslate('header.signOut', 'Sign Out', {
          nameSpace: 'ssr-resource',
        })}
      </a>
    )
  }

  oktaSignoutComponent = () => {
    const { isNuskinHeader = false } = this.props
    return (
      <button
        className={`${isNuskinHeader ? 'nu-sign-text' : ''
          } header-oktasignout-text`}
        onClick={signOutWithRedirect}
        data-testid="qa-sign-out">
        {i18nTranslate('header.signOut', 'Sign Out', {
          nameSpace: 'ssr-resource',
        })}
      </button>
    )
  }

  myFirstName = text => {
    let rtext = ''
    let len = String(text).length
    if (len > 12) {
      rtext = String(text).slice(0, 11).concat('...')
    } else {
      rtext = text
    }
    return rtext
  }

  myAccountComponent = () => {
    let redirectPageName =
      isB2BAccount() === true
        ? pageNames.b2bMyProfile
        : pageNames.myaccountprofile

    // CN locale users might get migrated for the July event site
    // My profile is disabled for them for non-event sites
    const enableLiveEvent = getLiveEventStatus()
    let disableMyAccount = ''
    if (enableLiveEvent !== 'true') {
      const homeCountry = customerContainer?.getUserHomeCountry()
      const isUserFromCN = homeCountry === 'CN'
      if (isUserFromCN) {
        redirectPageName = '#'
        disableMyAccount = 'event-user-disable-profile'
      }
    }

    const { isNuskinHeader = false } = this.props
    let contextValue = this.getContextValue()
    const ariaLabel =
      i18nTranslate('header.welcome', 'Hi', {
        nameSpace: 'ssr-resource',
      }) +
      ' ' +
      this.myFirstName(customerContainer.profileResponse.firstName)
    return (
      <Link
        to={redirectPageName}
        aria-label={ariaLabel}
        className={`${isNuskinHeader && contextValue !== ''
            ? 'nu-header-account-text-underline'
            : isNuskinHeader
              ? 'nu-header-account-text'
              : 'header-account-text'
          } ${disableMyAccount}`}
        // onClick={this.handleMobileMenu}
        data-testid="qa-account">
        {this.accountIcon()}
        {isNuskinHeader ? (
          <span className={`m-1 nu-sign-text des-display-user`}>
            {i18nTranslate('header.welcome', 'Hi', {
              nameSpace: 'ssr-resource',
            })}
            <span> </span>
            {this.myFirstName(customerContainer.profileResponse.firstName)}
          </span>
        ) : (
          <div className="header-account-text ml-1 display-desktop">
            <div className="user-name">
              {i18nTranslate('header.welcome', 'Hi', {
                nameSpace: 'ssr-resource',
              })}
            </div>
            <div className="user-firstName">
              {this.myFirstName(customerContainer.profileResponse.firstName)}
            </div>
          </div>
        )}
      </Link>
    )
  }

  userMenuDivider = () => {
    const { isNuskinHeader = false } = this.props
    return isNuskinHeader ? (
      <span className="signin-line nu-sign-text">/ </span>
    ) : (
      <span className="px-1 signin-line">|</span>
    )
  }

  registerUserComponent = () => {
    return (
      <>
        {this.myAccountComponent()}
        {this.userMenuDivider()}
        {customerContainer.isOktaUser || localStorage?.getItem('isOktaUser')
          ? this.oktaSignoutComponent()
          : this.signOutComponent()}
      </>
    )
  }

  registerUserOktaComponent = () => {
    const isAuthenticated = localStorage?.getItem('IsAuthenticated') || false
    const contextValue = this.getContextValue()
    /**
     * @info
     * currently making the localStorage of IsAuthenticated as true , because when user is
     * logged in via CSR this localStroage will be false ,this localstorage helps to render
     * the registerUserOktaComponents without lag during Locale change
     *
     */

    if (isAuthenticated !== true) {
      localStorage?.setItem('IsAuthenticated', true)
    }

    /**
     * @info
     *  using email to validate here , since for some users
     * firstname is null in customerAPI Responses which causes issue in
     * rendering the component
     *
     */

    const email =
      customerContainer?.profileResponse?.email ||
      customerContainer?.profileResponse?.phoneNumber ||
      customerContainer?.profileResponse?.userName ||
      customerContainer?.profileResponse?.userrole ||
      ''
    const enableQuickLinks = convertToBoolean(
      APPConfig?.getAppConfig()?.enableQuickLinks
    )

    const enableStoreCreditFlooredValue =
      typeof isFeatureEnabled === 'function' &&
      isFeatureEnabled('enableStoreCreditFlooredValue')

    if (email) {
      if (enableQuickLinks && !contextValue) {
        const remoteConfig = {
          appName: 'account-profile',
          component: 'QuickLinks',
        }
        const params = {
          customerData: customerContainer?.profileResponse,
          enableStoreCreditFlooredValue: enableStoreCreditFlooredValue,
          isFetchAllPromoCodeEnabled: isFetchAllPromoCodeEnabled(),
          enableLiveEvent: convertToBoolean(getLiveEventStatus()),
        }
        return (
          <div className="user-menu-mfe-wrapper">
            <MicroFrontendLoader remoteConfig={remoteConfig} params={params} />
          </div>
        )
      }

      return (
        <>
          {this.myAccountComponent()}
          {this.userMenuDivider()}
          {this.oktaSignoutComponent()}
        </>
      )
    }
  }

  guestUserComponent = () => {
    const { isNuskinHeader = false, enableLiveEvent = 'false' } = this.props
    const searchParams = new URLSearchParams(this.props?.location?.search || '')
    const code = searchParams?.get('code') || ''
    const state = searchParams?.get('state') || ''
    let contextValue = this.getContextValue()

    const disableFeatureForRP = customerContainer?.disableFeaturesForRPReview()
    return (
      <div className={IS_BROWSER && !code && !state ? '' : 'd-none'}>
        {enableLiveEvent !== 'true' ? (
          <>
            {!disableFeatureForRP && (
              <>
                {isNuskinHeader
                  ? contextValue == '' && this.signUpComponent()
                  : this.signInComponent()}
                {contextValue == '' && this.userMenuDivider()}
              </>
            )}
            {disableFeatureForRP && isNuskinHeader && (
              <span className="mob-display-signin-user">
                {this.accountIcon()}
              </span>
            )}
            {isNuskinHeader
              ? this.signInComponent()
              : contextValue == '' && this.signUpComponent()}
          </>
        ) : (
          isNuskinHeader && (
            <>
              {this.accountIcon()}
              {this.signInComponent()}
            </>
          )
        )}
      </div>
    )
  }

  getContextValue = () => {
    return isEquinoxMysite() || isEquinoxPOSite()
      ? ''
      : checkMysiteOrPersonalOffer()
  }

  render() {
    const { isNuskinHeader = false } = this.props
    const renderSignInSignUpComponent = customerContainer.isRegisterUser
      ? this.registerUserComponent
      : this.guestUserComponent

    const identified =
      customerContainer.profileResponse?.id ||
      customerContainer.profileResponse?.customer?.id ||
      undefined

    let renderOktaSignInSignUpComponent = () => ''

    if (identified) {
      /**
       * @info
       * Below condition of isRegisetered user is added in order to prevent Guest component
       * from loading for a second before actual registered user comp is renderd
       *
       */

      // const isRegisterUser =
      //   (customerContainer?.profileResponse?.email ||
      //     customerContainer?.profileResponse?.phoneNumber ||
      //     customerContainer?.profileResponse?.userName ||
      //     customerContainer?.profileResponse?.userrole ||
      //     false) &&
      //   (customerContainer?.profileResponse?.referenceAttribute != null ||
      //     false)

      let isGuestUser = customerContainer?.profileResponse?.guest || false
      const isRegisterUser =
        (customerContainer?.profileResponse?.email ||
          customerContainer?.profileResponse?.phoneNumber ||
          customerContainer?.profileResponse?.userName ||
          customerContainer?.profileResponse?.userrole ||
          false) &&
        customerContainer?.profileResponse?.referenceAttribute != null &&
        !isGuestUser

      renderOktaSignInSignUpComponent = isRegisterUser
        ? this.registerUserOktaComponent
        : this.guestUserComponent
    }

    const isAuthenticated = getCookie('x-role-user') ? true : false
    return (
      <>
        {isAuthenticated ? (
          renderOktaSignInSignUpComponent()
        ) : (
          <div
            className={`${isNuskinHeader ? '' : 'header-text'
              } mr-0 p-0 p-xs-0 p-lg-0 user-icon`}>
            {APPConfig.getAppConfig().signInType === 'okta'
              ? renderOktaSignInSignUpComponent()
              : renderSignInSignUpComponent()}
          </div>
        )}
        <SigninModal
          isVisible={this.isToShowSignInModal}
          onHideSignInModal={this.handleHideSignInModal}
          checkoutUrl={this.props}
        />
      </>
    )
  }
}

UserMenu.propTypes = {
  isNuskinHeader: PropTypes.bool,
  history: PropTypes.object,
  location: PropTypes.object,
  enableLiveEvent: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

export default UserMenu
export { UserMenu }
